<template>
    <v-container id="building-reference" fluid>
        <v-card-subtitle class="px-0">
            <v-icon :color="kingsGold" left>mdi-home-group</v-icon>Building Preference
        </v-card-subtitle>
        <v-row>
            <v-col cols="12" md="6">
                <v-select v-model="item.buildingOption01" :items="getBuildingsOptionOne"
                    label="Building Preference - First Choice" outlined :rules="buildingOption01Rules"
                    @change="resetRoommateOption1" dense>
                </v-select>
            </v-col>
            <v-col cols="12" md="6">
                <v-select v-model="item.buildingOption02" :items="getBuildingsOptionTwo"
                    label="Building Preference - Second Choice" outlined :rules="buildingOption02Rules"
                    @change="resetRoommateOption2" dense>
                </v-select>
            </v-col>
            <v-col cols="12">
                <v-select v-model="item.buildingUnitPreference" dense :items="buildingUnitPreferenceItems"
                    label="Unit Preference" outlined placeholder="Please select..." :rules="buildingUnitPreferenceRules"
                    required>
                </v-select>
            </v-col>
        </v-row>
        <v-card-subtitle class="px-0">
            <v-icon :color="kingsGold" left>mdi-basket</v-icon>Meal Plan Information
        </v-card-subtitle>
        <v-row>
            <v-col cols="12">
                <v-select v-model="item.residenceMealPlan" dense
                    hint="Note: These costs are approximate. Final costs are subject to Board approval."
                    :items="getResidenceMealPlanItems" label="Meal Plan" outlined persistent-hint
                    placeholder="Please select..." :rules="residenceMealPlanRules" required>
                </v-select>
            </v-col>
        </v-row>
        <v-card-subtitle class="pb-0 px-0">
            <v-icon :color="kingsGold" left>mdi-account-group</v-icon>Roommate Requests (Optional)
        </v-card-subtitle>
        <v-row>
            <v-col cols="12" lg="6">
                <v-card-subtitle class="px-0">
                    <b>{{ item.buildingOption01 || 'Building Preference - First Choice'  }}</b> -
                    Roommate
                    Requests (Optional)
                </v-card-subtitle>
                <v-alert v-if="!item.buildingOption01" :color="infoColor" dense icon="mdi-bell" text>Please
                    select your first building preference choice.
                </v-alert>
                <v-alert v-if="item.buildingOption01 && getBuildingRoommateOne == '0'" :color="warningColor" dense
                    icon="mdi-information" text>The residence building
                    <b>{{ item.buildingOption01 }}</b> does not allow any roommate requests.
                </v-alert>
                <v-form ref="roommateRequestForm01">
                    <v-text-field v-for="i in getBuildingRoommateOne" dense :key="i"
                        v-model="item.roommateRequest01[i-1]" :label="'Roommate Name #' + i" outlined>
                    </v-text-field>
                </v-form>
            </v-col>
            <v-col cols="12" lg="6">
                <v-card-subtitle class="px-0">
                    <b>{{ item.buildingOption02 || 'Building Preference - Second Choice'  }}</b>
                    -
                    Roommate
                    Requests (Optional)
                </v-card-subtitle>
                <v-alert v-if="!item.buildingOption02" :color="infoColor" dense icon="mdi-bell" text>Please
                    select your second building preference
                    choice.</v-alert>
                <v-alert v-if="item.buildingOption02 && getBuildingRoommateTwo == '0'" :color="warningColor" dense
                    icon="mdi-information" text>The residence building
                    <b>{{ item.buildingOption02 }}</b> does not allow any roommate requests.
                </v-alert>
                <v-form ref="roommateRequestForm02">
                    <v-text-field v-for="i in getBuildingRoommateTwo" dense :key="i"
                        v-model="item.roommateRequest02[i-1]" :label="'Roommate Name #' + i" outlined>
                    </v-text-field>
                </v-form>
            </v-col>
        </v-row>
        <v-card-subtitle class="px-0">
            <v-icon :color="kingsGold" left>mdi-history</v-icon>Have you ever lived in a
            College/University residence before?
        </v-card-subtitle>
        <v-row>
            <v-col cols="12">
                <v-select v-model="item.residencePrevious" dense :items="residencePreviousItems"
                    label="Previous residence experience" outlined :rules="residencePreviousRules" required>
                </v-select>
            </v-col>
            <v-col v-if="item.residencePrevious == 'Yes'" cols="12">
                <v-text-field v-model="item.residencePreviousLocation" dense label="Previous residence location"
                    outlined :rules="residencePreviousLocationRules">
                </v-text-field>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
export default {
    name: 'applicant-building-preference',
    props: {
        formSettings: {
            required: true
        },
        item: {
            required: true,
            type: Object
        }
    },
    data() {
        return {
            buildingUnitPreferenceItems: [{
                    text: 'Single Gender Unit',
                    value: 'Single Gender Unit'
                },
                {
                    text: 'Mixed Gender Unit',
                    value: 'Mixed Gender Unit'
                },
            ],
            buildingUnitPreferenceRules: [
                v => !!v || 'Unit preference is required'
            ],
            buildingOption01Rules: [
                v => !!v || 'First choice building preference is required'
            ],
            buildingOption02Rules: [
                v => !!v || 'Second choice building preference is required'
            ],
            genders: {
                F: 'Female',
                M: 'Male',
                Other: 'Other Gender Identity',
                NonBinary: 'NonBinary'
            },
            residenceMealPlanRules: [
                v => !!v || 'Residence meal plan is required'
            ],
            residencePreviousItems: [{
                    text: 'Yes',
                    value: 'Yes'
                },
                {
                    text: 'No',
                    value: 'No'
                }
            ],
            residencePreviousRules: [
                v => !!v || 'Please select an option for previous residence experience'
            ],
            residencePreviousLocationRules: [
                v => !!v || 'Previous residence location is required',
                v => (v && v.length >= 2) || 'Please provide a valid previous residence location',
            ],
            valid: true
        }
    },
    methods: {
        resetRoommateOption1() {
            // If option 2 becomes option 1
            if (this.item.buildingOption01 == this.item.buildingOption02) {
                this.$emit('resetBuildingOption2');
                this.resetRoommateOption2();
            }

            this.$refs.roommateRequestForm01.reset();
            this.$emit('resetRoommateOption1');
        },
        resetRoommateOption2() {
            this.$refs.roommateRequestForm02.reset();
            this.$emit('resetRoommateOption2');
        }
    },
    computed: {
        dangerColor() {
            return '#f64e60';
        },
        getBuildingsOptionOne() {
            let buildings = this.formSettings.buildings || [];
            let currentBuildings = [];
            let gender = this.genders[this.item.gender] || '';
            let yearOfStudy = this.item.yearOfStudy ? this.item.yearOfStudy.split(" ") : "";
            let yearLabel = yearOfStudy[0] ? yearOfStudy[0].toLowerCase() : "";
            let yearValue = yearOfStudy[1] || "";
            let reg = new RegExp(`^${gender}`, 'i');

            for (let i = 0; i < buildings.length; i++) {
                let genderBool = false;
                let internationalBool = true;
                let yearBool = true;

                // Gender restriction check
                if (gender && buildings[i].genderRestriction.length > 0) {
                    let restrictions = buildings[i].genderRestriction;

                    for (let j = 0; j < restrictions.length; j++) {
                        if (restrictions[j].match(reg)) {
                            genderBool = true;
                            break;
                        }
                    }
                } else if (gender) {
                    genderBool = true;
                }

                // Year of study restriction check
                if (yearLabel == "year" && yearValue && parseInt(buildings[i].minYearOfStudy) > parseInt(yearValue)) {
                    yearBool = false;
                }

                // International restriction check
                if (buildings[i].internationalOnly == "1" && this.item.internationalStudent == "No") {
                    internationalBool = false;
                }

                if (genderBool && internationalBool && yearBool) {
                    currentBuildings.push({
                        text: buildings[i].name,
                        value: buildings[i].name
                    });
                }
            }

            // Sort buildings list
            currentBuildings.sort((a, b) => a.text.localeCompare(b.text));

            return currentBuildings;
        },
        getBuildingsOptionTwo() {
            let buildings = this.formSettings.buildings || [];
            let currentBuildings = [];
            let gender = this.genders[this.item.gender] || '';
            let yearOfStudy = this.item.yearOfStudy ? this.item.yearOfStudy.split(" ") : "";
            let yearLabel = yearOfStudy[0] ? yearOfStudy[0].toLowerCase() : "";
            let yearValue = yearOfStudy[1] || "";
            let reg = new RegExp(`^${gender}`, 'i');

            for (let i = 0; i < buildings.length; i++) {
                if (buildings[i].name != this.item.buildingOption01) {
                    let genderBool = false;
                    let internationalBool = true;
                    let yearBool = true;

                    // Gender restriction check
                    if (gender && buildings[i].genderRestriction.length > 0) {
                        let restrictions = buildings[i].genderRestriction;

                        for (let j = 0; j < restrictions.length; j++) {
                            if (restrictions[j].match(reg)) {
                                genderBool = true;
                                break;
                            }
                        }
                    } else if (gender) {
                        genderBool = true;
                    }

                    // Year of study restriction check
                    if (yearLabel == "year" && yearValue && parseInt(buildings[i].minYearOfStudy) > parseInt(yearValue)) {
                        yearBool = false;
                    }

                    // International restriction check
                    if (buildings[i].internationalOnly == "1" && this.item.internationalStudent == "No") {
                        internationalBool = false;
                    }

                    if (genderBool && internationalBool && yearBool) {
                        currentBuildings.push({
                            text: buildings[i].name,
                            value: buildings[i].name
                        });
                    }
                }
            }

            // Sort buildings list
            currentBuildings.sort((a, b) => a.text.localeCompare(b.text));

            return currentBuildings;
        },
        getBuildingRoommateOne() {
            let buildings = this.formSettings.buildings || [];
            let max = 0;

            if (!this.item.buildingOption01) {
                return 0;
            }

            for (let i = 0; i < buildings.length; i++) {
                if (buildings[i].name == this.item.buildingOption01) {
                    max = buildings[i].maxRoommateRequest || max;
                }
            }

            return max;
        },
        getBuildingRoommateTwo() {
            let buildings = this.formSettings.buildings || [];
            let max = 0;

            if (!this.item.buildingOption02) {
                return 0;
            }

            for (let i = 0; i < buildings.length; i++) {
                if (buildings[i].name == this.item.buildingOption02) {
                    max = buildings[i].maxRoommateRequest || max;
                }
            }

            return max;
        },
        getResidenceMealPlanItems() {
            let buildings = this.formSettings.buildings || [];
            let mealPlanItems = [...this.formSettings.mealPlans];
            let required = false;

            // Slice
            mealPlanItems.length = 3;

            if (this.item.buildingOption01 || this.item.buildingOption02) {
                for (let i = 0; i < buildings.length; i++) {
                    if ((buildings[i].name == this.item.buildingOption01 || buildings[i].name == this.item.buildingOption02) && buildings[i].mealPlanRequired == "1") {
                        required = true;
                        break;
                    }
                }
            }

            // Required meal plan
            if (required) {
                return mealPlanItems;
            }

            return this.formSettings.mealPlans;
        },
        infoColor() {
            return '#5578eb';
        },
        kingsGold() {
            return '#d7ae28';
        },
        successColor() {
            return '#1bc5bd';
        },
        warningColor() {
            return '#ffb822'
        }
    }
}
</script>

<style scoped>
.col-12 {
    padding-bottom: 0;
    padding-top: 0;
}
</style>